import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getUserTrophies } from "../services/trophies.service";
import { userKeys } from "../queryKeys";
import { TrophiesResponse } from "../types/trophies.types";

const TROPHIES_PAGE_LIMIT = 10;

export const useUserTrophies = (userId: string | null, limit: number = TROPHIES_PAGE_LIMIT, offset: number = 0) => {
  const { i18n } = useTranslation();

  return useQuery<TrophiesResponse["data"], Error>({
    queryKey: [...userKeys.trophies(userId!), { limit, offset }, i18n.language],
    queryFn: async () => {
      const response = await getUserTrophies(userId!, limit, offset);
      return response.data;
    },
    enabled: !!userId,
  });
};
